import axios from 'axios';
import { APP_API_URL } from 'utils';

const geonamesAPI = axios.create({ baseURL: `${APP_API_URL}` });

export const getCountries = () => geonamesAPI.get('/geonames/country/');

export const getStates = gid => geonamesAPI.get(`/geonames/country/${gid}/regions/`);

export const getKYC = () => axios.get('/user/kyc_form/');
export const sendKYC = payload => axios.put('/user/kyc_form/', { ...payload });

export const saveKYCToRedis = payload => axios.post('/user/kyc_form/redis/save/', { ...payload });
export const getKYCFromRedis = () => axios.get('/user/kyc_form/redis/get/');
export const deleteKYCFromRedis = () => axios.delete('/user/kyc_form/redis/delete/');
export const setKYCStatusToRedis = status => axios.post('/user/kyc_form/redis/status/set/', { status });
export const getKYCStatusFromRedis = () => axios.get('/user/kyc_form/redis/status/get/');

export const setChangePasswordStatusToRedis = status => axios.post('/user/change_password/status/set/', { status });
export const getChangePasswordStatusFromRedis = () => axios.get('/user/change_password/status/get/');

export const sendDocuments = (name, files, side = null, poiDocType = null) => {
  const data = new FormData();
  const config = { headers: { 'content-type': 'multipart/form-data' } };

  files.forEach(file => {
    data.append('file', file);
  });
  if (side) {
    data.append('side', side);
  }
  if (poiDocType) {
    data.append('poiDocType', poiDocType);
  }

  return axios.post(`/user/document/${name}/`, data, config);
};

// eslint-disable-next-line camelcase
export const updatePOIDocType = poi_doc_type => axios.put('/user/poi_doc_type/', { poi_doc_type });

export const changePassword = payload => axios.post(`/auth/change_password/`, { ...payload });

export const getNotificationSettings = () => axios.get('/user/notification_settings/');

export const changeNotificationSettings = payload => axios.post('/user/notification_settings/', { ...payload });

export const getAgreements = () => axios.get(`/common/agreements/`);

export const getCards = () => axios.get(`/cards/list/`);

export const getCard = id => axios.get(`/cards/${id}/`);

export const deleteCard = id => axios.delete(`/cards/${id}/`);

export const updateCard = (cardId, formData) =>
  axios.put(`/cards/${cardId}/`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const addCard = data => {
  const config = { headers: { 'content-type': 'multipart/form-data' } };
  return axios.post(`/cards/add/`, data, config);
};

export const getSumSubToken = () => axios.get('/sumsub/get_token/');

export const deletePOIDocuments = () => axios.delete('/user/poi_reupload/');

// 拉取某文档类型下用户已上传的文档列表（含 id/status/side/poi_doc_type）
export const getUserDocuments = name => axios.get(`/user/document/${name}/`);

// 拉取单个文档文件内容（blob），用于预览
export const getUserDocumentFile = id => axios.get(`/user/document/${id}/file/`, { responseType: 'blob' });

// 删除单个文档（仅后端允许删 unverified）
export const deleteUserDocument = id => axios.delete(`/user/document/${id}/`);
